import { useContext, useMemo } from "react";
import { useLocation } from "react-router-dom";
import { ThemeStore } from "@foris/avocado-suite";
import { ContextEDH } from "@context/ContextEDH";
import useBookingAccess from "@common/hooks/useBookingAccess";
import logo from "@assets/svg/logoDarwin.svg";

const institutionsToAvoidLogo = ["ueuropea"];

const useGetInstitutionLogo = () => {
  const location = useLocation();
  const themeMode = ThemeStore.useThemeStore(state => state.theme.mode);
  const { state } = useContext(ContextEDH);
  const { isAdminBooking } = useBookingAccess();

  const institutionName = useMemo(() => {
    const defaultInstitutionName = "Darwin";

    if (state?.base?.institutionThemePreferences?.enabled) {
      return state?.base?.institutionThemePreferences?.institution || defaultInstitutionName;
    }

    return defaultInstitutionName;
  }, [state?.base?.institutionThemePreferences]);

  const institutionLogo = useMemo(() => {
    if (state?.base?.institutionThemePreferences?.enabled) {
      const isBookingPath = location.pathname.includes("booking");
      const institution = institutionName?.toLowerCase();
      const logoLight = state?.base?.institutionThemePreferences?.assets?.logo_light || logo;
      const logoDark = state?.base?.institutionThemePreferences?.assets?.logo_dark || logoLight;

      // Prevent showing the institution logo in the admin booking module
      // For now we if we are in the booking module, we will show the logo only for non admin users (Booking APP)
      if (
        (isAdminBooking && isBookingPath) ||
        // If we are not in the booking module, we will show the logo only for institutions that are not in the list
        (!isBookingPath && institutionsToAvoidLogo.includes(institution))
      ) {
        return logo;
      }

      return themeMode === "dark" ? logoDark : logoLight;
    }

    return logo;
  }, [state?.base?.institutionThemePreferences, isAdminBooking, location, institutionName]);

  return {
    logo: institutionLogo,
    name: institutionName,
  };
};

export default useGetInstitutionLogo;
